import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {VideoPlatformConfig} from '../video-platforms';
import {VideoInfo, VideoPlatformId, VideoRow} from '../video-types';

interface YouTubeOEmbedResponse {
  title: string;
  thumbnail_url: string;
  author_name: string;
  author_url: string;
  html: string;
  thumbnail_height: number;
  thumbnail_width: number;
}

export class YouTubePlatform extends VideoPlatformConfig {
  readonly name = 'YouTube';
  readonly id = VideoPlatformId.YOUTUBE;
  readonly patterns = [
    /^https?:\/\/(?:www\.)?youtube\.com\/watch\?v=([A-Za-z0-9_-]{11})/,
    /^https?:\/\/(?:www\.)?youtu\.be\/([A-Za-z0-9_-]{11})/
  ];
  readonly exampleLink = 'https://www.youtube.com/watch?v=GjZjZBxW3So';

  getInfo(row: VideoRow, http: HttpClient): Observable<VideoInfo> {
    const url = row.link || (row.code ? `https://www.youtube.com/watch?v=${row.code}` : '');
    return http.get<YouTubeOEmbedResponse>('https://www.youtube.com/oembed', {
      headers: this.httpHeaders,
      params: {url, format: 'json'}
    }).pipe(
      map(r => ({
        title: r.title,
        preview: r.thumbnail_url || this.getPreview(row),
        link: url
      })),
      catchError(() => this.createEmptyInfo(row))
    );
  }

  getPreview(row: VideoRow): string {
    const code = this.getVideoCode(row);
    return code ? `https://img.youtube.com/vi/${code}/hqdefault.jpg` : '';
  }
}
